<div class="mb-3 flex-1">
	<ui-section
		title="Personal Details"
		[collapsable]="true"
		[testHook]="testHooks.PersonalDetailsSection"
	>
		<div section-content>
			<div class="flex items-end">
				<app-dropdown
					label="Title"
					class="mr-5"
					[disabled]="false"
					[itemGroups]="titleOptions"
					[ngModel]="_client.title"
					(onSelect)="onTitleSelected($event)"
					[testHook]="testHooks.TitleDropdown"
				></app-dropdown>
				<app-input
					label="First name"
					[ngModel]="_client.firstName"
					(debounce)="onFirstNameChanged($event)"
					[required]="true"
					[submitted]="true"
					[testHook]="testHooks.FirstName"
				></app-input>
				<app-input
					label="Middle name(s)"
					[ngModel]="_client.middleNames"
					(debounce)="onMiddleNamesChanged($event)"
					[required]="false"
					[submitted]="true"
					class="mx-5"
					[testHook]="testHooks.Input"
				></app-input>
				<app-input
					label="Last name"
					[ngModel]="_client.lastName"
					(debounce)="onLastNameChanged($event)"
					[required]="true"
					[submitted]="true"
					[testHook]="testHooks.LastName"
				></app-input>
			</div>
			<div class="flex row">
				<app-input
					label="Preferred name"
					[ngModel]="_client.preferredName"
					(debounce)="onPreferredNameChanged($event)"
					[testHook]="testHooks.PreferredName"
				></app-input>
				<app-date-picker
					label="Birthdate"
					class="mx-5"
					[ngModel]="_client.dateOfBirth"
					startView="multi-year"
					(ngModelChange)="setDateOfBirth($event)"
					[testHook]="testHooks.BirthdateDatePicker"
				></app-date-picker>
				<app-radio-group
					label="Gender"
					[items]="genderOptions"
					type="compact"
					[ngModel]="_client.gender"
					(ngModelChange)="onGenderSelected($event)"
					[testHook]="testHooks.GenderRadioGroup"
				></app-radio-group>
			</div>
			<div class="flex justify-start row">
				<app-radio-group
					class="w-1/3 mr-5"
					name="resident"
					label="Canadian resident"
					[items]="yesNoOptions"
					(ngModelChange)="onResidentChange($event)"
					[ngModel]="_client.resident"
					[testHook]="testHooks.CanadianResidentRadioGroup"
				></app-radio-group>
				<app-radio-group
					*ngIf="_client.resident"
					[@fade]
					name="resident-status"
					class="w-1/3"
					label="Resident status"
					[items]="residentStatusOptions"
					(ngModelChange)="onResidentStatusChange($event)"
					[ngModel]="_client.residentStatus"
					[testHook]="testHooks.ResidentStatusRadioGroup"
				></app-radio-group>
			</div>

			<div class="flex flex-1 row items-end gap-5">
				<div>
					<app-select
						label="Representation type"
						[ngModel]="_client.representation"
						(ngModelChange)="onRepresentationSelected($event)"
						[testHook]="testHooks.RepresentationTypeSelect"
					>
						<option
							[value]="representationTypes.NONE"
							[testHook]="testHooks.Option"
						>
							None
						</option>
						<option
							[value]="representationTypes.ESTATE"
							[testHook]="testHooks.Option1"
						>
							Estate
						</option>
						<option
							[value]="representationTypes.ATTORNEY"
							[testHook]="testHooks.Option2"
						>
							Power of attorney
						</option>
					</app-select>
				</div>

				<ng-container
					*ngIf="_client.representation === representationTypes.ATTORNEY"
				>
					<app-date-picker
						label="Power of attorney date"
						[ngModel]="_client.powerOfAttorneyDate"
						(ngModelChange)="onPowerOfAttorneyDateChanged($event)"
						[testHook]="testHooks.PowerOfAttorneyDateDatePicker"
					></app-date-picker>
					<app-input
						label="Instrument Number"
						[ngModel]="_client.instrumentNumber"
						(debounce)="onInstrumentNumberChanged($event)"
						[testHook]="testHooks.InstrumentNumber"
					></app-input>
				</ng-container>
				<ng-container
					*ngIf="_client.representation === representationTypes.ESTATE"
				>
					<app-select
						label="Estate status"
						[ngModel]="_client.estateStatus"
						(ngModelChange)="onEstateStatusSelected($event)"
						placeholder="Select an option"
						[testHook]="testHooks.EstateStatusSelect"
					>
						<option
							[value]="estateStatusTypes.TESTATE"
							[testHook]="testHooks.Option3"
						>
							Testate
						</option>
						<option
							[value]="estateStatusTypes.INTESTATE"
							[testHook]="testHooks.Option4"
						>
							Intestate
						</option>
					</app-select>
					<app-input
						label="Instrument Number"
						[ngModel]="_client.instrumentNumber"
						(debounce)="onInstrumentNumberChanged($event)"
						[testHook]="testHooks.InstrumentNumber1"
					></app-input>
					<app-date-picker
						label="Date of death"
						[ngModel]="_client.dateOfDeath"
						startView="multi-year"
						(ngModelChange)="setDateOfDeath($event)"
						[testHook]="testHooks.DateOfDeathDatePicker"
					></app-date-picker>
				</ng-container>
			</div>
			<div class="flex row">
				<app-add-client-button
					*ngIf="addAssociateType"
					[type]="addAssociateType"
					[clientId]="_client.id"
				></app-add-client-button>
			</div>
			<app-client-tab-profile
				[client]="_client"
				[associations]="associations"
			></app-client-tab-profile>
		</div>
	</ui-section>

	<ui-section
		title="Contact Details"
		class="mt-5"
		[collapsable]="true"
		[locked]="contactsLocked"
		[subtitle]="contactsDeceasedSubtitle"
		[icon]="contactIcon"
		[testHook]="testHooks.ContactDetailsSection"
	>
		<div section-content>
			<div class="flex gap-5">
				<app-input
					label="Cell phone"
					name="phone"
					(debounce)="onCellChanged($event)"
					[ngModel]="_client.phone"
					[endIcon]="contactIcon"
					[disabled]="contactsLocked"
					[testHook]="testHooks.CellPhone"
				></app-input>
				<app-input
					label="Home phone"
					name="home"
					(debounce)="onHomeChanged($event)"
					[ngModel]="_client.home"
					[endIcon]="contactIcon"
					[disabled]="contactsLocked"
					[testHook]="testHooks.HomePhone"
				></app-input>
				<app-input
					label="Work phone"
					name="work"
					(debounce)="onWorkChanged($event)"
					[ngModel]="_client.work"
					[endIcon]="contactIcon"
					[disabled]="contactsLocked"
					[testHook]="testHooks.WorkPhone"
				></app-input>
			</div>
			<div class="flex row gap-5">
				<app-input
					label="Email"
					(debounce)="onEmailChanged($event)"
					[ngModel]="_client.email"
					[endIcon]="contactIcon"
					[disabled]="contactsLocked"
					[testHook]="testHooks.Email"
				></app-input>
				<app-input
					label="Occupation"
					class="mr-2"
					[disabled]="contactsLocked"
					[ngModel]="_client?.occupation"
					(debounce)="setOccupation($event)"
					[testHook]="testHooks.Occupation"
				></app-input>
			</div>
			<ui-section
				title="Addresses"
				[collapsable]="true"
				class="mt-5"
				[testHook]="testHooks.AddressesSection"
			>
				<div
					section-content
					*ngIf="matterId; else noMatter"
					class="flex flex-col gap-3"
				>
					<div class="flex justify-between items-center">
						<div class="flex flex-col">
							<app-button
								btn="link"
								size="small"
								*ngIf="
									address?.street &&
									address?.street !== _client?.serviceAddress?.street
								"
								(click)="setServiceAddress(address)"
								[testHook]="testHooks.SetServiceAddressButton"
								>Set to {{ address.street }}</app-button
							>
							<app-button
								btn="link"
								size="small"
								*ngIf="
									_client?.id === primaryClient?.id &&
									_client?.serviceAddress?.street &&
									!allClientsHaveSameServiceAddress
								"
								(click)="setAllClientToUseServiceAddress($event)"
								[testHook]="testHooks.ApplyThisAddressToAllClientsButton"
								>Apply this address to all clients</app-button
							>
							<app-button
								btn="link"
								size="small"
								*ngIf="
									_client?.serviceAddress?.street !==
									primaryClient?.serviceAddress?.street
								"
								(click)="setServiceAddress(primaryClient.serviceAddress)"
								[testHook]="testHooks.SetServiceAddressButton1"
								>Set to the same as {{ primaryClient | clientName }}</app-button
							>
						</div>
					</div>
					<app-address
						name="Service address"
						[disabled]="contactsLocked"
						[address]="_client?.serviceAddress"
						(onAddressUpdate)="setServiceAddress($event)"
						[enableCountrySelect]="true"
						[displayCountryTop]="false"
						class="mr-2"
						[testHook]="testHooks.ServiceAddress"
					>
					</app-address>
					<app-checkbox
						type="clear"
						class="mt-3"
						size="small"
						[ngModel]="sameReportAddress"
						(ngModelChange)="showReportAddress($event)"
						label="Report address same as Service address"
						[testHook]="testHooks.ReportAddressSameAsServiceAddressCheckbox"
					></app-checkbox>

					<div
						[@openClose]
						*ngIf="!sameReportAddress"
						class="pt-3 flex flex-col"
					>
						<div class="flex justify-between">
							<div class="flex flex-col">
								<app-button
									btn="link"
									size="small"
									*ngIf="
										address?.street &&
										address?.street !== _client?.reportAddress?.street &&
										fileType === fileTypes.PURCHASE
									"
									(click)="setReportAddress(address)"
									[testHook]="testHooks.SetReportAddressButton"
									>Set to {{ address.street }}</app-button
								>
								<app-button
									btn="link"
									size="small"
									*ngIf="
										_client?.id === primaryClient?.id &&
										_client?.reportAddress?.street &&
										!allClientsHaveSameReportAddress
									"
									(click)="setAllClientToUseReportAddress($event)"
									[testHook]="testHooks.ApplyThisAddressToAllClientsButton1"
									>Apply this address to all clients</app-button
								>
								<app-button
									btn="link"
									size="small"
									*ngIf="
										(!primaryClient?.reportAddress &&
											_client?.reportAddress?.street !==
												primaryClient?.serviceAddress?.street) ||
										(primaryClient?.reportAddress &&
											_client?.reportAddress?.street !==
												primaryClient?.reportAddress?.street)
									"
									(click)="
										setReportAddress(
											primaryClient?.reportAddress ||
												primaryClient?.serviceAddress
										)
									"
									[testHook]="testHooks.SetReportAddressButton1"
									>Set to the same as {{ primaryClient | clientName }}
								</app-button>
							</div>
						</div>
						<app-address
							name="Report address"
							*ngIf="!sameReportAddress"
							[disabled]="contactsLocked"
							[displayCountryTop]="false"
							[address]="_client?.reportAddress"
							(onAddressUpdate)="setReportAddress($event)"
							[enableCountrySelect]="true"
							class="mr-2 mt-5"
							[testHook]="testHooks.ReportAddress"
						>
						</app-address>
					</div>

					<app-address
						name="Business address"
						[disabled]="contactsLocked"
						[displayCountryTop]="false"
						[address]="_client?.businessAddress"
						(onAddressUpdate)="setBusinessAddress($event)"
						[enableCountrySelect]="true"
						class="mr-2 mt-5"
						[testHook]="testHooks.BusinessAddress"
					>
					</app-address>
				</div>
			</ui-section>
			<ng-template #noMatter>
				<div section-content class="flex flex-col gap-3">
					<app-address
						name="Service address"
						[disabled]="contactsLocked"
						[displayCountryTop]="false"
						[address]="_client?.serviceAddress"
						(onAddressUpdate)="setServiceAddress($event)"
						[enableCountrySelect]="true"
						class="mr-2"
						[testHook]="testHooks.ServiceAddress1"
					>
					</app-address>

					<app-checkbox
						type="clear"
						class="mt-1 text-sm"
						size="small"
						[ngModel]="sameReportAddress"
						(ngModelChange)="showReportAddress($event)"
						label="Report address same as Service address"
						[testHook]="testHooks.ReportAddressSameAsServiceAddressCheckbox1"
					></app-checkbox>
					<app-address
						*ngIf="!sameReportAddress"
						name="Report address"
						[disabled]="contactsLocked"
						[displayCountryTop]="false"
						[address]="_client?.reportAddress"
						(onAddressUpdate)="setReportAddress($event)"
						[enableCountrySelect]="true"
						[testHook]="testHooks.ReportAddress1"
					>
					</app-address>

					<app-address
						name="Business address"
						[disabled]="contactsLocked"
						[displayCountryTop]="false"
						[address]="_client?.businessAddress"
						(onAddressUpdate)="setBusinessAddress($event)"
						[enableCountrySelect]="true"
						[testHook]="testHooks.BusinessAddress1"
					>
					</app-address>
				</div>
			</ng-template>
		</div>
	</ui-section>

	<ui-section title="Employer Details" [collapsable]="true" class="mt-5">
		<div section-content>
			<app-employer-details [client_]="_client" />
		</div>
	</ui-section>

	<ui-section
		title="Salutations"
		class="mt-5"
		[collapsable]="true"
		[testHook]="testHooks.SalutationsSection"
	>
		<div section-content class="flex flex-1">
			<app-text-area
				label="Re: line"
				[ngModel]="_client.reLine"
				(debounce)="onReLineChanged($event)"
				[testHook]="testHooks.TextArea"
			></app-text-area>
			<div class="ml-3 flex flex-1 flex-col">
				<app-input-wrapper
					label="Primary salutation"
					[testHook]="testHooks.PrimarySalutationInputWrapper"
				>
					<div class="flex">
						<app-select
							[ngModel]="_client.primarySalutationOption"
							(ngModelChange)="onPrimarySalutationTypeChanged($event)"
							[testHook]="testHooks.PrimarySalutationTypeSelect"
						>
							<option
								[value]="salutationTypes.FORMAL"
								[testHook]="testHooks.Option5"
							>
								Formal
							</option>
							<option
								[value]="salutationTypes.INFORMAL"
								[testHook]="testHooks.Option6"
							>
								Informal
							</option>
							<option
								[value]="salutationTypes.CUSTOM"
								[testHook]="testHooks.Option7"
							>
								Custom
							</option>
						</app-select>
						<app-input
							class="ml-5"
							[ngModel]="primarySalutation"
							(debounce)="onPrimarySalutationChanged($event)"
							[testHook]="testHooks.PrimarySalutation"
						></app-input>
					</div>
				</app-input-wrapper>
				<app-input-wrapper
					label="Envelope salutation"
					class="row"
					[testHook]="testHooks.EnvelopeSalutationInputWrapper"
				>
					<div class="flex">
						<app-select
							[ngModel]="_client.envelopeSalutationOption"
							(ngModelChange)="onEnvelopeSalutationTypeChanged($event)"
							[testHook]="testHooks.EnvelopeSalutationTypeSelect"
						>
							<option
								[value]="salutationTypes.FORMAL"
								[testHook]="testHooks.Option8"
							>
								Formal
							</option>
							<option
								[value]="salutationTypes.INFORMAL"
								[testHook]="testHooks.Option9"
							>
								Informal
							</option>
							<option
								[value]="salutationTypes.CUSTOM"
								[testHook]="testHooks.Option10"
							>
								Custom
							</option>
						</app-select>
						<app-input
							class="ml-5"
							[ngModel]="envelopeSalutation"
							(debounce)="onEnvelopeSalutationChanged($event)"
							[testHook]="testHooks.EnvelopeSalutation"
						></app-input>
					</div>
				</app-input-wrapper>
				<app-input
					class="row"
					label="Envelope salutation (continued)"
					[ngModel]="_client.envelopeSalutationContd"
					(debounce)="onEnvelopeSalutationContChanged($event)"
					[testHook]="testHooks.Input1"
				></app-input>
			</div>
		</div>
	</ui-section>
</div>
